<template>
  <div class="panel-body">
    <h4 v-if="showUsers.Message">Message: {{ showUsers.Message }}</h4>
    <h1 class="logo-desc">Programming Hub</h1>
    <!-- modal comments -->
    <div class="container">
      <!-- Modal -->
      <!-- <div class="modal fade" id="myModal1" role="dialog" v-if="showmodal"> -->
      <div class="modal fade" id="myModal1" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">
                Certificate ID:
                <span
                  v-if="userInfo && userInfo.certificate_id"
                >{{userInfo.certificate_id}}</span>
              </h4>
            </div>
            <div class="modal-body" v-if="userInfo && userInfo.name">
              Name:
              <!-- <input type="text" v-model="userInfo.name" /> -->
              <input type="text" v-model="userNametoBeEdited" />
              <button
                data-dismiss="modal"
                class="btn btn-primary btn-float-right"
                @click="updateCert(userInfo)"
              >Update</button>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal create new certificates -->
      <!-- <div class="modal fade" id="myModal2" role="dialog" v-if="showmodalCreateNewCertificate" > -->
      <div class="modal fade" id="myModal2" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button ref="close" type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">Create New Certificate</h4>
            </div>
            <div class="modal-body">
              <!-- email, language, name, date -->
              <form @submit.prevent="submitNewCertificate" v-if="!loaderCertificate">
                <div class="form-group row">
                  <label for="staticEmail" class="col-sm-2 col-form-label">Email</label>
                  <div class="col-sm-10">
                    <input
                      v-model="certificateEmail"
                      required
                      type="email"
                      class="form-control"
                      id="staticEmail"
                      placeholder="Email"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="inputLanguage" class="col-sm-2 col-form-label">Language</label>
                  <div class="col-sm-10">
                    <select v-model="selectedLanguage" class="custom-select form-control">
                      <option selected>Please select any language</option>
                      <option
                        v-for="(language, index) in userLanguageList"
                        :key="index"
                        :value="language.language_id"
                      >{{ language.name }}</option>
                      <!-- <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>-->
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="staticName" class="col-sm-2 col-form-label">Name</label>
                  <div class="col-sm-10">
                    <input
                      v-model="certificateName"
                      required
                      type="text"
                      class="form-control"
                      id="staticName"
                      placeholder="Name"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="certificate" class="col-sm-2 col-form-label">Certificate</label>
                  <div class="col-sm-10">
                    <select v-model="certificateType" class="custom-select form-control">
                      <option selected>Please select</option>
                      <option
                        v-for="(certificate, index) in certificateList"
                        :key="index"
                        :value="certificate.id"
                      >{{ certificate.name }}</option>
                      <!-- <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>-->
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="staticSubmit" class="col-sm-2 col-form-label"></label>
                  <div class="col-sm-10">
                    <!-- data-dismiss="modal" -->
                    <input
                      :disabled=" certificateEmail && certificateName && selectedLanguage === 'Please select any language'"
                      type="submit"
                      class="btn btn-primary pull-left"
                      id="staticSubmit"
                    />
                  </div>
                </div>
              </form>
              <div style="height: 195px" v-else>
                <ball-triangle-path-loader color="#000000" size="20px"></ball-triangle-path-loader>
              </div>
              <div v-if="errorMessage">
                <h2 style="color: red">{{ errorMessage }}</h2>
              </div>
            </div>
            <!-- <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <!-- modal comments ENDS -->
    <!--============== loader ================-->
    <triangle-loader v-if="loader" />
    <!--================ loader ends ==============-->
    <!--=============== alert ==================-->
    <div class="alert alert-success alert-dismissible" v-if="showData.alertCert">
      <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
      <strong>Success!</strong> it will take 1-2 minutes to update.
    </div>
    <!--================ alert =================-->
    <!--#################@### MAIN TABLE ############## -->
    <table v-show="!loader" class="table table-hover">
      <thead>
        <tr>
          <th colspan="12" class="customBg">
            <div class="text-center">
              <form @submit.prevent="searchCert">
                Filter By:
                <select v-model="selectCertEmail">
                  <option value="certificate_id">Certificate Id</option>
                  <option value="email">Email Id</option>
                </select>&nbsp;
                <input type="text" v-model="searchCertHere" :placeholder="selectCertEmail" /> &nbsp;
                <button type="submit" class="mr-5 btn btn-lg">Search</button>
                <!-- @click="showmodalCreateNewCertificate = true, errorMessage = ''" -->
                <button
                  type="button"
                  class="btn btn-lg"
                  data-toggle="modal"
                  @click="errorMessage = ''"
                  data-target="#myModal2"
                >Create New Certificate</button>
              </form>
            </div>
          </th>
        </tr>
        <tr>
          <th>certificate_id</th>
          <th>email_id</th>
          <th>name</th>
          <th>language_id</th>
          <th>CertImg</th>
          <th>certPDF</th>
          <th>Edit</th>
        </tr>
      </thead>
      <tbody>
        <!-- <tr v-for="(info, index) in showUsers.data" :key="index"> -->
        <tr v-for="(info, index) in paginatedData" :key="index">
          <td>{{info.certificate_id}}</td>
          <td>{{info.email_id}}</td>
          <td>{{info.name}}</td>
          <td>{{info.language_id}}</td>
          <td>
            <a :href="info.certImgLink" target="_blank" class="btn btn-sm btn-primary">img</a>
          </td>
          <td>
            <a :href="info.certPDFLink" target="_blank" class="btn btn-sm btn-primary">PDF</a>
          </td>
          <td>
            <button
              type="button"
              @click="showModal(info)"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              data-target="#myModal1"
            >EDIT</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="showButton">
      <button
        @click="prevPage"
        :disabled="pageNumber==0"
        type="button"
        class="btn btn-primary"
      >Previous</button>
      &nbsp;
      <strong>{{ pageNumber+1 }}</strong>
      / {{ Math.ceil(this.showData.TotalPagesCert/100) }}
      &nbsp;
      <button
        @click="nextPage"
        :disabled="pageNumber == (Math.ceil(this.showData.TotalPagesCert/100)-1)"
        type="button"
        class="btn btn-primary"
      >Next</button>
    </div>
    <br />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import ToggleButton from "vue-js-toggle-button";
// import Paginate from "vuejs-paginate";

import "vue-loaders/dist/vue-loaders.css";
import * as VueLoaders from "vue-loaders";
Vue.use(VueLoaders);

// Vue.component("paginate", Paginate);
Vue.use(ToggleButton);
export default {
  name: "tabulardata",
  props: {
    size: {
      type: Number,
      required: false,
      default: 10
    }
  },
  data() {
    return {
      data: "",
      showmodal: false,
      // showmodalCreateNewCertificate: false,
      userInfo: null,
      comments: null,
      // currentPage: 3,
      showQueryModalData: false,
      // pageNumber: 0
      selectedLanguage: "Please select any language",
      certificateType: "Please select",
      certificateEmail: "",
      certificateName: "",
      currDate: new Date(),
      loaderCertificate: false,
      errorMessage: "",
      userNametoBeEdited: "",
      certificateList: [
        {
          name: 'Certificate of Excellence',
          id: 'excellence'
        },
        {
          name: 'Certificate of Completion',
          id: 'completion'
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      showData: "showData",
      showMessage: "showMessage",
      // showReason: "showReason",
      showUsers: "showUsers",
      showUsersCert: "showUsersCert",
      loader: "showLoader"
    }),
    pageNumber: {
      set: function(val) {
        this.$store.commit("updatePageNumber", val);
      },
      get: function() {
        return this.showData.pageNumber;
      }
    },
    searchCertHere: {
      set: function(val) {
        this.$store.commit("updateSearchCertHere", val);
      },
      get: function() {
        return this.showData.searchCertHere;
      }
    },
    selectCertEmail: {
      set: function(val) {
        this.$store.commit("updateSelectCertEmail", val);
      },
      get: function() {
        return this.showData.selectCertEmail;
      }
    },
    showButton: {
      set: function(val) {
        this.$store.commit("updateShowButton", val);
      },
      get: function() {
        return this.showData.showButton;
      }
    },
    userLanguageList: {
      set: function(val) {
        this.$store.commit("setUserLanguageList", val);
      },
      get: function() {
        return this.showData.languageList;
      }
    },
    pageCount() {
      let l = this.showUsersCert.length,
        s = this.size;
      return Math.ceil(l / s);
    },
    paginatedData() {
      const start = this.pageNumber * this.size,
        end = start + this.size;
      if (this.showUsersCert) {
        // return this.showUsersCert.slice(start, end);
        return this.showUsersCert;
      } else {
        return null;
      }
    }
  },
  mounted() {
    this.getUser();
    this.modeSet();
    this.getUserLanguageList();
  },
  methods: {
    ...mapActions([
      "updateDataCert",
      "getUserDataCert",
      "setMode",
      "searchCert_",
      "getLanguageList",
      "createNewCertificate"
    ]),
    getUserLanguageList: function() {
      this.getLanguageList({
        mode: this.showData.mode
      });
    },
    getUser: function() {
      this.getUserDataCert({
        mode: this.showData.mode,
        pageNum: this.pageNumber + 1
      });
    },
    showQueryModal() {
      this.showQueryModalData = true;
    },
    closeAddQuery() {
      this.showQueryModalData = false;
    },
    modeSet: function() {
      this.setMode({ mode: this.showData.mode });
    },
    searchCert: function() {
      if (this.searchCertHere) {
        this.searchCert_({ mode: this.showData.mode });
        this.showButton = false;
        this.searchCertHere = null;
      } else {
        return;
      }
    },

    updateCert: async function(info) {
      try {
        var response = await this.updateDataCert({
          mode: this.showData.mode,
          certificate_id: info.certificate_id,
          // name: info.name
          name: this.userNametoBeEdited
        });
        if (response) {
          if (response && response.data && response.data.Reason) {
            Vue.toasted.show(response.data.Message + ' ' + response.data.Reason, {
              type: "success",
              theme: "toasted-primary",
              position: "top-right",
              duration: 6000
            });
          }
          this.getUser();
        }
      } catch (err) {
        return err;
      }
    },
    showModal: function(info) {
      this.userNametoBeEdited = "";
      this.userNametoBeEdited = info.name;
      this.showmodal = true;
      this.userInfo = info;
    },
    nextPage() {
      this.pageNumber++;
      this.getUser();
    },
    prevPage() {
      this.pageNumber--;
      this.getUser();
    },
    submitNewCertificate() {
      this.errorMessage = "";
      this.loaderCertificate = true;
      var closeModal = this.$refs.close;
      if (this.certificateType !== "Please select") {
         var data = {
        certificate_type: this.certificateType,
        email_id: this.certificateEmail,
        language_id: this.selectedLanguage,
        name: this.certificateName,
        date: this.currDate
          .toISOString()
          .split("T")[0]
          .replace(/-/g, "/")
      };
      } else {
        var data = {
        email_id: this.certificateEmail,
        language_id: this.selectedLanguage,
        name: this.certificateName,
        date: this.currDate
          .toISOString()
          .split("T")[0]
          .replace(/-/g, "/")
      };
      }
      this.createNewCertificate({
        mode: this.showData.mode,
        data: data
      }).then(res => {
        if (!res.data.Message) {
          closeModal.click();
          (this.certificateEmail = ""),
            (this.selectedLanguage = "Please select any language"),
            (this.certificateName = "");
            this.certificateType = 'Please select'
          this.loaderCertificate = false
        } else {
          (this.certificateEmail = ""),
            (this.selectedLanguage = "Please select any language"),
            (this.certificateName = "");
            this.loaderCertificate = false;
          this.loaderCertificate = false;
          this.errorMessage = res.data.Message;
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo-desc {
  font-size: 30px;
  font-weight: bold;
  letter-spacing: 0.6px;
  text-align: center;
  color: #494949;
  padding: 14px 0px 14px 18px;
}
.customAlignLeft {
  text-align: left;
}
.btn-float-right {
  float: right;
}
.customBg {
  background: #ffffff;
  color: black;
}
.customWidthhundred {
  width: 100%;
  line-height: 0;
}
.customColorSelect {
  color: #353434;
}
/* Rounded sliders */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* Rounded slider end */
/*pagination*/
.pagination {
  float: left;
}
.page-item {
  float: left;
}
/* table style */
.table-fill {
  background: white;
  border-radius: 3px;
  border-collapse: collapse;
  height: 320px;
  margin: auto;
  max-width: 600px;
  padding: 5px;
  width: 100%;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  animation: float 5s infinite;
}

th {
  color: #d5dde5;
  background: #1b1e24;
  border-bottom: 4px solid #9ea7af;
  border-right: 1px solid #343a45;
  font-size: 23px;
  font-weight: 100;
  padding: 24px;
  text-align: left;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  vertical-align: middle;
}

th:first-child {
  border-top-left-radius: 3px;
}

th:last-child {
  border-top-right-radius: 3px;
  border-right: none;
}

tr {
  border-top: 1px solid #c1c3d1;
  border-bottom: 1px solid #c1c3d1;
  color: #666b85;
  font-size: 16px;
  font-weight: normal;
  text-shadow: 0 1px 1px rgba(256, 256, 256, 0.1);
}

tr:hover td {
  background: #4e5066;
  color: #ffffff;
  border-top: 1px solid #22262e;
}

tr:first-child {
  border-top: none;
}

tr:last-child {
  border-bottom: none;
}

tr:nth-child(odd) td {
  background: #ebebeb;
}

tr:nth-child(odd):hover td {
  background: #4e5066;
}

tr:last-child td:first-child {
  border-bottom-left-radius: 3px;
}

tr:last-child td:last-child {
  border-bottom-right-radius: 3px;
}

td {
  background: #ffffff;
  padding: 20px;
  text-align: left;
  vertical-align: middle;
  font-weight: 300;
  font-size: 18px;
  text-shadow: -1px -1px 1px rgba(0, 0, 0, 0.1);
  border-right: 1px solid #c1c3d1;
}

td:last-child {
  border-right: 0px;
}

th.text-left {
  text-align: left;
}

th.text-center {
  text-align: center;
}

th.text-right {
  text-align: right;
}

td.text-left {
  text-align: left;
}

td.text-center {
  text-align: center;
}

td.text-right {
  text-align: right;
}
.mr-5 {
  margin-right: 3rem;
}
</style>
